import { render } from "./Next.vue?vue&type=template&id=2c57d6e7&ts=true"
import script from "./Next.vue?vue&type=script&lang=ts"
export * from "./Next.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__